export const ZOOM_OVERLAY_COLORS = {
  default: 'rgba(0, 0, 0, 0.75)',
  educacion: 'rgba(255, 0, 0, 0.75)',
  expExiPreciones: 'rgba(8, 84, 184, 0.75)',
  residentes: 'rgba(248, 231, 28, 0.75)',
  materialesResidencia: 'rgba(173, 173, 173, 0.75)',
};
